import { initLenis } from './modules/lenis';
import { setupLinkTransitions, initView } from './modules/transitions';
import { gsap } from 'gsap';
import { iniSliderPosts } from './modules/slider-posts';
import { initSliderKeyFigures } from './modules/slider-key-figures';
import { initDropdownFilter } from './modules/dropdown-filter';
import { initMainNav } from './modules/menu';
import { initAnimations } from './modules/animations';
import { initVideoOverlay } from './modules/video-overlay';

const animationAnchor = (lenis) => {
  const anchors = document
    .querySelector("#content")
    .querySelectorAll("a[href^='#']");

  anchors.forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      e.preventDefault();
      const id = anchor.getAttribute("href");
      lenis.scrollTo(id, { duration: 2 });
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const lenis = initLenis();
  initView();
  iniSliderPosts();
  setupLinkTransitions();
  initSliderKeyFigures();
  animationAnchor(lenis);
  initDropdownFilter();
  initMainNav(lenis);
  initAnimations();
  initVideoOverlay();
});

// Gestion du retour navigateur (bfcache)
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;

  const app = document.querySelector('#app');
  if (!app) return;

  gsap.killTweensOf(app);

  gsap.set(app, { opacity: 1, y: 0 });
  gsap.set('.o-site-header', { autoAlpha: 1, y: 0 });
  gsap.set('.o-contact__outer', { opacity: 1, scale: 1 });
});
